import { get } from "lodash";

import {
  DocumentStatus,
  documentStatusSelectItems,
} from "~/components/Forms/CreateDocument/utils/utils";
import { IDocumentChangeStatusForm } from "~/components/Forms/DocumentStatusForm";

export const labelsForDocumentStatus = documentStatusSelectItems.reduce(
  (acc, { value, label }) => ({ ...acc, [value]: label }),
  {} as Record<DocumentStatus, string>
);

export const dataToRequest_SetStatus = (data: IDocumentChangeStatusForm) => ({
  status: data.status,
  canceledReason: data.canceledReason,
});

export const userHaveAccessToDocumentEdit = (
  data,
  documentInstance,
  hasEditPermission: boolean,
) => {
  const profile = get(data, "UserGetter.getProfile", {});

  return !(
    documentInstance.createdBy.toLowerCase() ===
      profile.fullname.toLowerCase() || hasEditPermission
  );
};
